const validateFieldWithRules = (formObject, obj, field, fieldRules) => {
  const rules = [
    'required',
    'conditionalRequired',
    'minItems',
    'maxItems',
    'minValue',
    'maxValue',
    'func',
    'pattern'
  ]
  const validationRules = {}

  validationRules.minValue = (field = '') => {
    const valid = (formObject[field] || '').length >= fieldRules.minValue
    return {
      valid,
      errorMessage: `Este campo deve conter no mínimo ${fieldRules.minValue} dígitos.`
    }
  }

  validationRules.maxValue = (field = '') => {
    const valid = (formObject[field] || []).length <= fieldRules.maxValue
    return {
      valid,
      errorMessage: `Este campo deve conter no máximo ${fieldRules.maxValue} dígitos.`
    }
  }

  validationRules.minItems = (field = '') => {
    const valid = (formObject[field] || []).length >= fieldRules.minItems
    return {
      valid,
      errorMessage: `Este campo deve conter no mínimo ${fieldRules.minItems} medicamentos.`
    }
  }

  validationRules.maxItems = (field = '') => {
    const valid = (formObject[field] || []).length <= fieldRules.maxItems
    return {
      valid,
      errorMessage: `Este campo deve conter no máximo ${fieldRules.maxItems} medicamentos.`
    }
  }

  validationRules.func = (field = '') => {
    const valid = !!fieldRules.func(formObject[field])
    const errorMessage = fieldRules.errorMessage || 'Campo incorreto.'

    return { valid, errorMessage }
  }

  validationRules.pattern = (field = '') => {
    const valid = !!fieldRules.pattern.test(formObject[field])
    return { valid, errorMessage: 'Campo incorreto.' }
  }

  validationRules.required = (field = '', errorMessage = 'Este campo é obrigatório.') => {
    let valid = true
    if (field === 'pesoDA') {
      valid = !!formObject[field] && !!String(formObject[field]).length > 0
      valid = formObject[field] >= 0 && formObject[field] !== ''
    } else {
      if (field === 'editores' && ((formObject || {}).tipo || '') === 'artigo') {
        return { valid, errorMessage }
      }
      valid = !!formObject[field] && !!String(formObject[field]).length > 0
    }
    return { valid, errorMessage }
  }

  validationRules.conditionalRequired = (field = '') => {
    if (typeof fieldRules.conditionalRequired === 'function') {
      const { required, errorMessage } = fieldRules.conditionalRequired(formObject)
      return required ? validationRules.required(field, errorMessage) : { valid: true }
    } else {
      const err = new Error('conditionalRequired must be a function')
      return validationRules.required(field)
    }

    // const valid = !!formObject[field] && !!String(formObject[field]).length > 0
    // return { valid, errorMessage: 'Este campo é obrigatório.' }
  }

  if (!fieldRules['required'] && !formObject[field] && !fieldRules['conditionalRequired']) {
    const newObject = {}

    newObject[field] = {
      valid: true
    }
    return { ...obj, ...newObject }
  }

  for (let rule of rules) {
    if (fieldRules[rule]) {
      const { valid = true, errorMessage = '' } = validationRules[rule]
        ? validationRules[rule](field)
        : true
      const newObject = {}

      newObject[field] = {
        valid,
        errorMessage
      }

      if (!valid) {
        return { ...obj, ...newObject }
      }
    }
  }
}

export default class ValidateFormObject {
  constructor(schema) {
    this.schema = schema
  }

  validate = ({ formObject = {}, invalidFields = {}, formSchemaType = 'add' }) => {
    if (!this.schema[formSchemaType]) {
      return { valid: true, fields: {} }
    }
    const getFieldError = (obj, item) => {
      const [field, rules] = item
      if (invalidFields[field]) {
        const newObject = {}
        newObject[field] = invalidFields[field]
        return { ...obj, ...newObject }
      }

      const validFieldWithRules = validateFieldWithRules(formObject, obj, field, rules)

      if (validFieldWithRules) {
        return validFieldWithRules
      }

      const newObject = {}
      newObject[field] = { valid: true }
      return { ...obj, ...newObject }
    }

    const formErrors = Object.entries(this.schema[formSchemaType]).reduce(getFieldError, {})
    for (let item of Object.entries(formErrors)) {
      const [key, value] = item // eslint-disable-line
      if (!value.valid) {
        return { fields: formErrors, valid: false }
      }
    }

    return { valid: true, fields: formErrors }
  }
}

export const validates = {
  /* eslint-disable */
  cpf(cpf) {
    cpf = cpf.replace(/^([0-9]{3})\.([0-9]{3})\.([0-9]{3})-([0-9]{2})$/, '$1$2$3$4')
    if (cpf + '' === '00000000000') {
      return true
    }
    let numbers, digits, sum, i, result, digits_equals
    digits_equals = 1
    if (cpf.length < 11) return false
    for (i = 0; i < cpf.length - 1; i++)
      if (cpf.charAt(i) != cpf.charAt(i + 1)) {
        digits_equals = 0
        break
      }
    if (!digits_equals) {
      numbers = cpf.substring(0, 9)
      digits = cpf.substring(9)
      sum = 0
      for (i = 10; i > 1; i--) sum += numbers.charAt(10 - i) * i
      result = sum % 11 < 2 ? 0 : 11 - (sum % 11)
      if (result != digits.charAt(0)) return false
      numbers = cpf.substring(0, 10)
      sum = 0
      for (i = 11; i > 1; i--) sum += numbers.charAt(11 - i) * i
      result = sum % 11 < 2 ? 0 : 11 - (sum % 11)
      if (result != digits.charAt(1)) return false
      return true
    } else return false
  },
  cnpj(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, '')

    if (cnpj == '') return false

    if (cnpj.length != 14) return false

    if (
      cnpj == '00000000000000' ||
      cnpj == '11111111111111' ||
      cnpj == '22222222222222' ||
      cnpj == '33333333333333' ||
      cnpj == '44444444444444' ||
      cnpj == '55555555555555' ||
      cnpj == '66666666666666' ||
      cnpj == '77777777777777' ||
      cnpj == '88888888888888' ||
      cnpj == '99999999999999'
    )
      return false

    let tamanho = cnpj.length - 2
    let numeros = cnpj.substring(0, tamanho)
    let digitos = cnpj.substring(tamanho)
    let soma = 0
    let pos = tamanho - 7
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--
      if (pos < 2) pos = 9
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
    if (resultado != digitos.charAt(0)) return false

    tamanho = tamanho + 1
    numeros = cnpj.substring(0, tamanho)
    soma = 0
    pos = tamanho - 7
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--
      if (pos < 2) pos = 9
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
    if (resultado != digitos.charAt(1)) return false

    return true
  },
  email(email) {
    const valid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email
    )
    return !!valid
  },
  isbn(isbn = '') {
    const value = `${isbn}`.trim().length
    return /13/.test(value)
  },
  date(date = '') {
    const value = `${date}`.trim().length
    return /10/.test(value)
  },
  issn(issn = '') {
    const value = `${issn}`.trim().length
    return /9/.test(value)
  },
  copyright(copyright = '') {
    return !!(`${copyright}`.trim().length === 4)
  },
  codigoCapitulo(codigoCapitulo = '') {
    return /[0-9]{13}_S[0-9]{2}C[0-9]{3}/.test(`${codigoCapitulo}`)
  },
  codigoArtigoDiretriz(codigo) {
    codigo = codigo.replace('-', '')
    const validLength = /[0-9]{11}/.test(codigo)

    if (!validLength) return false

    let numbers, digits, sum, i, result, digits_equals
    digits_equals = 1
    if (codigo.length < 11) return false
    for (i = 0; i < codigo.length - 1; i++)
      if (codigo.charAt(i) != codigo.charAt(i + 1)) {
        digits_equals = 0
        break
      }
    if (!digits_equals) {
      numbers = codigo.substring(0, 9)
      digits = codigo.substring(9)
      sum = 0
      for (i = 10; i > 1; i--) sum += numbers.charAt(10 - i) * i
      result = sum % 11 < 2 ? 0 : 11 - (sum % 11)
      if (result != digits.charAt(0)) return false
      numbers = codigo.substring(0, 10)
      sum = 0
      for (i = 11; i > 1; i--) sum += numbers.charAt(11 - i) * i
      result = sum % 11 < 2 ? 0 : 11 - (sum % 11)
      if (result != digits.charAt(1)) return false
      return true
    } else return false
  },
  codigo(codigo = '') {
    return /[0-9]{13}_S[0-9]{2}C[0-9]{3}[aAfFiIqQtT][0-9]{3}[a-z-A-Z-0-9]{0,1}/.test(`${codigo}`)
  },
  isNumber(value) {
    return !!Number(value)
  }
  /* eslint-enable */
}



// WEBPACK FOOTER //
// ./src/utils/ValidateFormObject.js